function EuroIcon({ size = '22', color = '#3A416F', style = {} }) {
  return (
    <svg
      style={{ ...style }}
      width={size}
      height={size}
      viewBox="0 0 24 25"
      fill="none"
    >
      <path
        d="M5.00012 14.9025H7.67623C8.66738 19.2708 12.2355 21.3008 16.3364 21.3008C17.2656 21.3008 18.4922 21.2108 19.0001 21.0181V18.9368C18.455 19.1038 17.2656 19.168 16.3364 19.168C13.3134 19.168 10.8975 17.819 10.0302 14.9025H16.7205V13.3607H9.74525C9.70809 13.0395 9.6957 12.6926 9.6957 12.3457V12.3201C9.6957 11.9218 9.72048 11.5363 9.75764 11.1766H16.7205V9.63483H10.0674C10.9594 6.76973 13.3506 5.43354 16.3364 5.43354C17.2656 5.43354 18.455 5.52348 19.0001 5.66481V3.58344C18.4798 3.40356 17.2656 3.30078 16.3364 3.30078C12.2727 3.30078 8.70455 5.29222 7.68862 9.63483H5.00012V11.1766H7.45322C7.41605 11.5363 7.40366 11.8961 7.40366 12.2815V12.3072C7.40366 12.6669 7.41605 13.0267 7.44083 13.3607H5.00012V14.9025Z"
        fill="url(#paint0_linear)"
      />
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="-1.99988"
          y1="12.3008"
          x2="15.4463"
          y2="25.87"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={color} />
          <stop offset="1" stopColor={color} />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default EuroIcon;
